<template>
  <v-container
    id="HappyQuest"
    fluid
    tag="section"
  >
    <!-- Gestion des filtres d'entreprise -->
    <v-row v-if="isAdmin && !idCompany">
      <v-card
        flat
        class="pr-2"
      >
        {{ $t('Filters.Label.SelectCompanies') }}
      </v-card>
      <v-col>
        <companies-filter
          :is-admin="isAdmin"
          :id-company="idCompany"
          @set-companies="selectedCompanies = $event"
        />
      </v-col>
    </v-row>

    <!-- Gestion des filtres de tag -->
    <v-row>
      <v-card
        flat
        class="pr-7"
      >
        {{ $t('Filters.Label.SelectTags') }}
      </v-card>
      <v-col>
        <tags-filter
          :is-admin="isAdmin"
          :id-company="idCompany"
          :company-list="selectedCompanies"
          @set-tags="selectedTags = $event"
        />
      </v-col>
    </v-row>

    <!-- Boutons de restriction de dates -->
    <v-row>
      <v-card flat>
        {{ $t('Filters.Label.Btn') }}
      </v-card>
      <v-row
        align="center"
        justify="space-around"
      >
        <v-btn
          class="ma-1"
          color="bluecolor"
          outlined
          @click="changeDates('week')"
        >
          {{ $t('Filters.Btn.Week') }}
        </v-btn>
        <v-btn
          class="ma-1"
          color="bluecolor"
          outlined
          @click="changeDates('month')"
        >
          {{ $t('Filters.Btn.Month') }}
        </v-btn>
        <v-btn
          class="ma-1"
          color="bluecolor"
          outlined
          @click="changeDates('3months')"
        >
          {{ $t('Filters.Btn.3Months') }}
        </v-btn>
      </v-row>
    </v-row>

    <!-- Gestion des filtres de date -->
    <v-row>
      <v-col cols="6">
        <date-filter
          :label="startDate.label"
          :default-date="startDate.date"
          @set-date="startDate.date = $event"
        />
      </v-col>
      <v-col cols="6">
        <date-filter
          :label="endDate.label"
          :default-date="endDate.date"
          @set-date="endDate.date = $event"
        />
      </v-col>
    </v-row>

    <!-- Bouton de validation des filtres -->
    <v-row justify="center">
      <v-btn
        class="ma-1"
        color="bluecolor"
        rounded
        @click="emitFilters()"
      >
        {{ $t('Filters.Btn.ValidateFilters') }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import TagsFilter from './TagsFilter.vue'
  import CompaniesFilter from './CompaniesFilter.vue'
  import DateFilter from './DateFilter.vue'
  import moment from 'moment'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'HappyQuest',

    /* Sous-composants utilisés par ce composant */
    components: {
      TagsFilter,
      CompaniesFilter,
      DateFilter,
    },

    /* Paramètres */
    props: {
      idCompany: {
        type: String,
        default: undefined,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        startDate: {
          label: 'Date de début',
          date: undefined,
        },
        endDate: {
          label: 'Date de fin',
          date: undefined,
        },
        selectedTags: [],
        selectedCompanies: [],
      }
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      filters: function () {
        return {
          startDate: this.startDate.date,
          endDate: this.endDate.date,
          selectedTags: this.selectedTags,
          selectedCompanies: this.selectedCompanies,
        }
      },
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      idCompany: function (newVal) {
        this.getCompanyDefaultDate(newVal)
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.endDate.date = moment().format()
      this.getCompanyDefaultDate(this.idCompany, true)
    },

    /* Fonctions internes */
    methods: {
      emitFilters: function () {
        this.$emit('set-filters', this.filters)
      },

      changeDates: function (period) {
        switch (period) {
          case 'week':
            //  définition de la date à j-7
            this.startDate.date = moment().subtract(7, 'days').format('YYYY-MM-DD')
            break

          case 'month':
            //  définition de la date à m-1
            this.startDate.date = moment().subtract(1, 'months').format('YYYY-MM-DD')
            break

          case '3months':
            //  définition de la date à m-3
            this.startDate.date = moment().subtract(3, 'months').format('YYYY-MM-DD')
            break

          default:
            this.startDate.date = moment().subtract(7, 'days').format('YYYY-MM-DD')
            break
        }
        this.endDate.date = moment().format('YYYY-MM-DD')
      },

      getCompanyDefaultDate: function (idCompany, toEmit = false) {
        if (!idCompany) {
          // Récupération de la date dans le profil connecté
          this.$Auth.getCompanyDetails(this.$Auth.getProfile().sub)
            .then(datas => {
              this.startDate.date = moment(datas.createdAt).format()
              if (toEmit) {
                this.emitFilters()
              }
            })
            .catch((/* error */) => {
              this.startDate.date = moment().format()
              if (this.isAdmin) {
                // console.log('Error in ' + this.$options.name + ' : ', error)
              }
            })
        } else {
          // Récupération de la date de l'entreprise
          this.$Auth.httpRequest(
            'get',
            'api/company/selectCompanyDetailsById?companyId=' + idCompany,
          )
            .then(datas => {
              this.startDate.date = moment(datas.data[0].createdAt).format()
              if (toEmit) {
                this.emitFilters()
              }
            })
            .catch((/* error */) => {
              this.startDate.date = moment().format()
              if (this.isAdmin) {
                // console.log('Error in ' + this.$options.name + ' : ', error)
              }
            })
        }
      },
    },
  }
</script>
